import React, { Component } from 'react';
import { Link } from 'react-router';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

class MobileNav extends Component {

  constructor(props) {
    super(props);
    this.hideMenu = this.hideMenu.bind(this);
    this.showMenu = this.showMenu.bind(this);
    this.renderMenu = this.renderMenu.bind(this);

    this.state = {
      showMenu: false
    };
  }

  hideMenu() {
    this.setState({showMenu: false});
    document.body.className = "";
    document.documentElement.className = "";
  }

  showMenu() {
    this.setState({showMenu: true});
    document.body.className = "disable-scroll";
    document.documentElement.className = "disable-scroll";
  }

  renderMenu() {
    return (
      <div className="menu-mobile background-blue">
        <a className="menu-trigger-close link-reset" onClick={this.hideMenu}>
          <span className="menu-line line-diagonal-1"></span>
          <span className="menu-line line-diagonal-2"></span>
        </a>
        <div className="page-container-responsive text-contrast">
          <div className="row space-top-4">
            <div className="col-sm-12">
              <h2 className="space-3"><Link to="/" onClick={this.hideMenu}>Home</Link></h2>
              <h2 className="space-3"><Link to="/faq" onClick={this.hideMenu}>Faq</Link></h2>
              <h2 className="space-3"><Link to="/building-managers" onClick={this.hideMenu}>Building Managers</Link></h2>
              <h2><Link to="/get-the-app">Get the app</Link></h2>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderTrigger() {
    return (
      <a className="menu-trigger show-sm" onClick={this.showMenu}>
        <span className="menu-line"></span>
        <span className="menu-line"></span>
        <span className="menu-line"></span>
      </a>
    )
  }

  render() {
    return(
      <div>
        {this.renderTrigger()}
        <ReactCSSTransitionGroup transitionName="animation" transitionEnterTimeout={200} transitionLeaveTimeout={200}>
          {this.state.showMenu ? this.renderMenu() : ''}
        </ReactCSSTransitionGroup>
      </div>
    )
  }
}

export default MobileNav;



/** WEBPACK FOOTER **
 ** ./src/components/MobileNav.js
 **/